import { render, staticRenderFns } from "./apisChemAccident.vue?vue&type=template&id=8eae9bcc"
import script from "./apisChemAccident.vue?vue&type=script&lang=js"
export * from "./apisChemAccident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eae9bcc')) {
      api.createRecord('8eae9bcc', component.options)
    } else {
      api.reload('8eae9bcc', component.options)
    }
    module.hot.accept("./apisChemAccident.vue?vue&type=template&id=8eae9bcc", function () {
      api.rerender('8eae9bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/apis/apisChemAccident.vue"
export default component.exports